module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "sec-3"
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "images/1.jpg"
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h1_01",
      "role": "doc-chapter",
      "title": "CONTENTS"
    }
  }, [_c('h1', {
    staticClass: "chapter",
    attrs: {
      "id": "pAjb"
    }
  }, [_c('b', [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "cctt"
  }, [_c('a', {
    attrs: {
      "href": "#/instructions#ab_01",
      "id": "ba_01"
    }
  }, [_c('em', [_vm._v("Ebook Instructions")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pz3-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter02#ab_02",
      "id": "ba_02"
    }
  }, [_c('em', [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "pz3-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter03#ab_03",
      "id": "ba_03"
    }
  }, [_c('b', [_vm._v("1. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("PSALM")]), _vm._v(" 19:14")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "pz3-4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#ab_04",
      "id": "ba_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gospel In, Gospel Out")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "pz3-5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#ab_05",
      "id": "ba_05",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("2. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("ACTS")]), _vm._v(" 4:29–30")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "pz3-6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter06#ab_06",
      "id": "ba_06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prayer for Boldness")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "pz3-7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter07#ab_07",
      "id": "ba_07",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("3. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("EXODUS")]), _vm._v(" 33:15–16")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "pz3-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter08#ab_08",
      "id": "ba_08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Presence of God")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "pz3-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter09#ab_09",
      "id": "ba_09",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("4. 1 "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("SAMUEL")]), _vm._v(" 2:2, 8")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "pz3-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10#ab_10",
      "id": "ba_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("No One Like the Lord")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "pz3-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter11#ab_11",
      "id": "ba_11",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("5. 2 "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("CHRONICLES")]), _vm._v(" 20:12")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "pz3-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter12#ab_12",
      "id": "ba_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fix Our Eyes")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "pz3-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter13#ab_13",
      "id": "ba_13",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("6. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("ISAIAH")]), _vm._v(" 25:1")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "pz3-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter14#ab_14",
      "id": "ba_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Faithful and Sure")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "pz3-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter15#ab_15",
      "id": "ba_15",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("7. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("JEREMIAH")]), _vm._v(" 15:16")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "pz3-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter16#ab_16",
      "id": "ba_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Delight of My Heart")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "pz3-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter17#ab_17",
      "id": "ba_17",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("8. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("PSALM")]), _vm._v(" 119:31")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "pz3-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter17a#ab_17a",
      "id": "ba_17a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cling")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "pz3-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter18#ab_18",
      "id": "ba_18",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("9. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("JOB")]), _vm._v(" 42:5")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct2",
    attrs: {
      "id": "pz3-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter19#ab_19",
      "id": "ba_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("But Now")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pz3-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter20#ab_20",
      "id": "ba_20",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("10. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("PSALM")]), _vm._v(" 5:3")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "pz3-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter21#ab_21",
      "id": "ba_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Praying with Expectation")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pz3-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter22#ab_22",
      "id": "ba_22",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("11. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("PSALM")]), _vm._v(" 51:12")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "pz3-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter23#ab_23",
      "id": "ba_23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Joy")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pz3-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter24#ab_24",
      "id": "ba_24",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("12. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("PSALM")]), _vm._v(" 56:3–4")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "pz3-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter25#ab_25",
      "id": "ba_25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Faith over Fear")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pz3-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter26#ab_26",
      "id": "ba_26",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("13. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("ISAIAH")]), _vm._v(" 26:3")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "pz3-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter27#ab_27",
      "id": "ba_27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prayer of Peace")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pz3-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter28#ab_28",
      "id": "ba_28",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("14. 1 "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("KINGS")]), _vm._v(" 3:9")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "pz3-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter28a#ab_28a",
      "id": "ba_28a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Good and Evil")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pAN9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter29#ab_29",
      "id": "ba_29",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("15. 2 "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("SAMUEL")]), _vm._v(" 7:18")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "Ayr"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter30#ab_30",
      "id": "ba_30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Count Your Blessings")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pAPz"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter31#ab_31",
      "id": "ba_31",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("16. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("NUMBERS")]), _vm._v(" 6:24–26")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "pAGC"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter31a#ab_31a",
      "id": "ba_31a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pray for One Another")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pAlq"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter32#ab_32",
      "id": "ba_32",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("17. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("PSALM")]), _vm._v(" 9:10")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "pAlx"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter33#ab_33",
      "id": "ba_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Not Forsaken")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pA34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter34#ab_34",
      "id": "ba_34",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("18. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("MATTHEW")]), _vm._v(" 26:39")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "pAht"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter35#ab_35",
      "id": "ba_35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Will of the Father")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pA38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter36#ab_36",
      "id": "ba_36",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("19. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("PSALM")]), _vm._v(" 143:12")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "pAL7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter37#ab_37",
      "id": "ba_37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I Am Your Servant")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pAGd"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter38#ab_38",
      "id": "ba_38",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("20. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("PSALM")]), _vm._v(" 4:7")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "pA1R"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter39#ab_39",
      "id": "ba_39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gladness from God")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pAy7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter40#ab_40",
      "id": "ba_40",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("21. 2 "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("KINGS")]), _vm._v(" 6:17")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "pALz"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter42#ab_42",
      "id": "ba_42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Open Our Eyes")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pA40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter43#ab_43",
      "id": "ba_43",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("22. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("PSALM")]), _vm._v(" 139:23–24")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "pAsy"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter44#ab_44",
      "id": "ba_44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fully Known")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pA6V"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter45#ab_45",
      "id": "ba_45",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("23. 1 "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("SAMUEL")]), _vm._v(" 1:11")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "pART"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter46#ab_46",
      "id": "ba_46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prayer of Faith")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pAUl"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter47#ab_47",
      "id": "ba_47",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("24. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("PSALM")]), _vm._v(" 145:5")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "pA-"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter48#ab_48",
      "id": "ba_48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prayer of Praise")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pAhT"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter49#ab_49",
      "id": "ba_49",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("25. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("JEREMIAH")]), _vm._v(" 32:17")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "pAYe"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter50#ab_50",
      "id": "ba_50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nothing Too Hard")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pABq"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter51#ab_51",
      "id": "ba_51",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("26. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("PSALM")]), _vm._v(" 131:1")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "pAyF"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter52#ab_52",
      "id": "ba_52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prayer of Trust")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pAcs"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter53#ab_53",
      "id": "ba_53",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("27. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("ACTS")]), _vm._v(" 1:24–25")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "pA62"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter54#ab_54",
      "id": "ba_54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Big Decisions")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pA4U"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter55#ab_55",
      "id": "ba_55",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("28. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("PSALM")]), _vm._v(" 22:3–4")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "pAja"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter56#ab_56",
      "id": "ba_56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("You Are Holy")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pAV7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter57#ab_57",
      "id": "ba_57",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("29. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("PSALM")]), _vm._v(" 86:11")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "pAF"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter58#ab_58",
      "id": "ba_58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("One Step at a Time")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "AaV"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter59#ab_59",
      "id": "ba_59",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("30. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("PSALM")]), _vm._v(" 18:1–2")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "AsY"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter60#ab_60",
      "id": "ba_60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reliable Defender")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "AEvQ"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter61#ab_61",
      "id": "ba_61",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("31. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("PSALM")]), _vm._v(" 64:1–2")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "pAAL"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter62#ab_62",
      "id": "ba_62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hear, Help, Hide")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pARa"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter63#ab_63",
      "id": "ba_63",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("32. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("PSALM")]), _vm._v(" 72:16")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "pA5Z"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter64#ab_64",
      "id": "ba_64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prayer for Our Communities")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pAQn"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter65#ab_65",
      "id": "ba_65",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("33. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("EXODUS")]), _vm._v(" 15:6")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "pAXO"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter66#ab_66",
      "id": "ba_66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Glorious in Power")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pAx98"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter67#ab_67",
      "id": "ba_67",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("34. 1 "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("KINGS")]), _vm._v(" 19:4")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "pAMZ"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter68#ab_68",
      "id": "ba_68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Honest Prayer")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pAyq"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter69#ab_69",
      "id": "ba_69",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("35. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("GENESIS")]), _vm._v(" 24:12")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "pAt5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter70#ab_70",
      "id": "ba_70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prayer for Success")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pA0g"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter71#ab_71",
      "id": "ba_71",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("36. 2 "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("SAMUEL")]), _vm._v(" 7:28")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "pA-b"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter72#ab_72",
      "id": "ba_72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("True Words")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pA-NC"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter73#ab_73",
      "id": "ba_73",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("37. 1 "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("KINGS")]), _vm._v(" 8:56")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "pAFE"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter74#ab_74",
      "id": "ba_74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prayer to the Promise Keeper")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pAul"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter75#ab_75",
      "id": "ba_75",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("38. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("DANIEL")]), _vm._v(" 9:18")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "pAK_"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter76#ab_76",
      "id": "ba_76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Because of Mercy")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pA-F"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter77#ab_77",
      "id": "ba_77",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("39. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("JOHN")]), _vm._v(" 12:28")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "pAN9U"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter78#ab_78",
      "id": "ba_78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Your Name")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pAMf"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter79#ab_79",
      "id": "ba_79",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("40. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("PSALM")]), _vm._v(" 119:132")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "pALe"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter80#ab_80",
      "id": "ba_80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("God’s Custom")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pAIl"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter81#ab_81",
      "id": "ba_81",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("41. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("PSALM")]), _vm._v(" 90:12")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "pAfr"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter82#ab_82",
      "id": "ba_82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Number Our Days")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pAqC"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter83#ab_83",
      "id": "ba_83",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("42. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("PSALM")]), _vm._v(" 61:1–2")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "pAn9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter84#ab_84",
      "id": "ba_84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Higher Than I")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pAOX"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter85#ab_85",
      "id": "ba_85",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("43. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("PSALM")]), _vm._v(" 23:1")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "pAX_"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter86#ab_86",
      "id": "ba_86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I Shall Not Want")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pAmq"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter87#ab_87",
      "id": "ba_87",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("44. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("PSALM")]), _vm._v(" 85:6")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "pAj7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter88#ab_88",
      "id": "ba_88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prayer for Revival")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pA0h"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter89#ab_89",
      "id": "ba_89",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("45. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("PROVERBS")]), _vm._v(" 30:7–9")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "pA2b"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter90#ab_90",
      "id": "ba_90",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Honest, Simple Life")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pAWS"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter91#ab_91",
      "id": "ba_91",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("46. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("PSALM")]), _vm._v(" 25:4–5")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "pApy"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter92#ab_92",
      "id": "ba_92",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Your Ways")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pApB"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter93#ab_93",
      "id": "ba_93",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("47. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("EPHESIANS")]), _vm._v(" 3:17–19")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "pA7Q"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter94#ab_94",
      "id": "ba_94",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Love of Christ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pAq7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter95#ab_95",
      "id": "ba_95",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("48. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("JEREMIAH")]), _vm._v(" 12:3")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "A_xo"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter96#ab_96",
      "id": "ba_96",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The God Who Sees")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "A52k"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter97#ab_97",
      "id": "ba_97",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("49. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("JONAH")]), _vm._v(" 4:2")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "Agcj"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter98#ab_98",
      "id": "ba_98",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prayer of Confession")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pAIf"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter99#ab_99",
      "id": "ba_99",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("50. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("GENESIS")]), _vm._v(" 32:9")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "pAka"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter100#ab_100",
      "id": "ba_100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prayer to Overcome Fear")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pAV0"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter101#ab_101",
      "id": "ba_101",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("51. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("EPHESIANS")]), _vm._v(" 3:20–21")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "pAoQ"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter102#ab_102",
      "id": "ba_102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Above and Beyond")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pAHru"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter103#ab_103",
      "id": "ba_103",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("52. 2 "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("KINGS")]), _vm._v(" 6:18")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "pAba"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter104#ab_104",
      "id": "ba_104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prayer Against an Enemy")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pAgn"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter105#ab_105",
      "id": "ba_105",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("53. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("PHILIPPIANS")]), _vm._v(" 1:9–10")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "pAhDI"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter106#ab_106",
      "id": "ba_106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prayer for Discernment")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pAcn"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter107#ab_107",
      "id": "ba_107",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("54. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("NUMBERS")]), _vm._v(" 12:13")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "pAol-"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter108#ab_108",
      "id": "ba_108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prayer for Healing")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pAvV"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter109#ab_109",
      "id": "ba_109",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("55. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("JOHN")]), _vm._v(" 17:9")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "pAao"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter110#ab_110",
      "id": "ba_110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jesus Prays for Us")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pAK8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter111#ab_111",
      "id": "ba_111",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("56. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("JUDGES")]), _vm._v(" 13:8")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "pAUO"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter112#ab_112",
      "id": "ba_112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prayer for Parenting")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pAsLB"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter113#ab_113",
      "id": "ba_113",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("57. 2 "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("KINGS")]), _vm._v(" 20:3")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "pAqiZ"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter114#ab_114",
      "id": "ba_114",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Power of Prayer")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pAlTW"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter115#ab_115",
      "id": "ba_115",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("58. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("JOB")]), _vm._v(" 32:21")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "pASI-"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter116#ab_116",
      "id": "ba_116",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prayer for Godly Relationships")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pA5Z0"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter117#ab_117",
      "id": "ba_117",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("59. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("PSALM")]), _vm._v(" 17:15")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "pAP7B"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter118#ab_118",
      "id": "ba_118",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prayer of Satisfaction")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pAT9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter119#ab_119",
      "id": "ba_119",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("60. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("JOHN")]), _vm._v(" 17:15")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "pAfz"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter120#ab_120",
      "id": "ba_120",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prayer for Protection")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pAlS"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter121#ab_121",
      "id": "ba_121",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("61. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("JUDGES")]), _vm._v(" 10:15")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "pA8e"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter122#ab_122",
      "id": "ba_122",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prayer of Trust")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pAq_X"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter123#ab_123",
      "id": "ba_123",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("62. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("PSALM")]), _vm._v(" 32:7")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "pAQJ"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter124#ab_124",
      "id": "ba_124",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prayer of Preservation")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pAK9k"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter125#ab_125",
      "id": "ba_125",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("63. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("PSALM")]), _vm._v(" 51:1")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "pAORh"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter126#ab_126",
      "id": "ba_126",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prayer for Restoration")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pAj2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter127#ab_127",
      "id": "ba_127",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("64. 2 "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("THESSALONIANS")]), _vm._v(" 1:11–12")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "pAjxq"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter128#ab_128",
      "id": "ba_128",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Glorified in Us")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pAyQ"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter129#ab_129",
      "id": "ba_129",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("65. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("COLOSSIANS")]), _vm._v(" 4:3")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "pADf"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter130#ab_130",
      "id": "ba_130",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prayer for an Open Door")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pAQ95"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter131#ab_131",
      "id": "ba_131",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("66. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("PSALM")]), _vm._v(" 3:2–3")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "ALq7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter132#ab_132",
      "id": "ba_132",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("But You, O Lord")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pAFU"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter133#ab_133",
      "id": "ba_133",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("67. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("PSALM")]), _vm._v(" 16:11")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "Ayk4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter134#ab_134",
      "id": "ba_134",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fullness of Joy")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pAdb"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter135#ab_135",
      "id": "ba_135",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("68. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("PSALM")]), _vm._v(" 18:39")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "AHi"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter136#ab_136",
      "id": "ba_136",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prayer for Battle")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pAd6U"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter137#ab_137",
      "id": "ba_137",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("69. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("PSALM")]), _vm._v(" 104:6–7")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "AHp"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter138#ab_138",
      "id": "ba_138",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In His Hands")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pA6K"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter139#ab_139",
      "id": "ba_139",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("70. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("PSALM")]), _vm._v(" 108:1")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "ALuR"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter140#ab_140",
      "id": "ba_140",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Steadfast Heart")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pAD5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter141#ab_141",
      "id": "ba_141",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("71. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("LUKE")]), _vm._v(" 22:32")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "ADe"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter142#ab_142",
      "id": "ba_142",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Strengthen Your Brethren")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pAFu"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter143#ab_143",
      "id": "ba_143",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("72. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("PSALM")]), _vm._v(" 130:3")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "ApOn"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter144#ab_144",
      "id": "ba_144",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Who Could Stand?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pAAuQ"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter145#ab_145",
      "id": "ba_145",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("73. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("PSALM")]), _vm._v(" 119:37")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "Ao2x"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter146#ab_146",
      "id": "ba_146",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Worthless Things")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pAu0"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter147#ab_147",
      "id": "ba_147",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("74. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("JONAH")]), _vm._v(" 2:1–2")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "ASS1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter148#ab_148",
      "id": "ba_148",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Because of My Affliction")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pAAOA"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter149#ab_149",
      "id": "ba_149",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("75. 2 "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("KINGS")]), _vm._v(" 19:15")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "ADn3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter150#ab_150",
      "id": "ba_150",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("You Are God")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pAyI"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter151#ab_151",
      "id": "ba_151",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("76. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("PSALM")]), _vm._v(" 119:11")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "AqoL"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter152#ab_152",
      "id": "ba_152",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hidden Truth")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pAOGX"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter153#ab_153",
      "id": "ba_153",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("77. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("PSALM")]), _vm._v(" 122:6–7")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "Ac9X"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter154#ab_154",
      "id": "ba_154",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peace and Prosperity")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pAa6O"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter155#ab_155",
      "id": "ba_155",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("78. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("NEHEMIAH")]), _vm._v(" 6:9")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "AVjS"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter156#ab_156",
      "id": "ba_156",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Strengthen My Hands")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pAnfZ"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter157#ab_157",
      "id": "ba_157",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("79. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("PSALM")]), _vm._v(" 25:5")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "Aot"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter158#ab_158",
      "id": "ba_158",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Patience")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pA2bM"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter159#ab_159",
      "id": "ba_159",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("80. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("PSALM")]), _vm._v(" 139:9–10")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "AgGr"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter160#ab_160",
      "id": "ba_160",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Even There")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pAqC1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter161#ab_161",
      "id": "ba_161",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("81. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("PSALM")]), _vm._v(" 23:4")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "AUQ"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter162#ab_162",
      "id": "ba_162",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Walk Through the Valley")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pAyW"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter163#ab_163",
      "id": "ba_163",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("82. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("PSALM")]), _vm._v(" 51:7")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "Am6l"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter164#ab_164",
      "id": "ba_164",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Purge Me with Hyssop")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pAKQg"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter165#ab_165",
      "id": "ba_165",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("83. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("PSALM")]), _vm._v(" 16:5–6")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "ARb"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter166#ab_166",
      "id": "ba_166",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Good Inheritance")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pAu-K"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter167#ab_167",
      "id": "ba_167",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("84. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("PSALM")]), _vm._v(" 141:3")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "APRy"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter168#ab_168",
      "id": "ba_168",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Guard My Mouth")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pADM5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter169#ab_169",
      "id": "ba_169",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("85. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("LUKE")]), _vm._v(" 23:34")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "Ao2G"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter170#ab_170",
      "id": "ba_170",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Father, Forgive Them")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pAlG3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter171#ab_171",
      "id": "ba_171",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("86. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("EXODUS")]), _vm._v(" 2:23")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "AIun"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter172#ab_172",
      "id": "ba_172",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Wordless Prayer")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pAYTv"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter173#ab_173",
      "id": "ba_173",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("87. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("JUDGES")]), _vm._v(" 1:1")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "ADGy"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter174#ab_174",
      "id": "ba_174",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prayer for Direction")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pANv"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter175#ab_175",
      "id": "ba_175",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("88. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("PSALM")]), _vm._v(" 71:24")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "AsQ2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter176#ab_176",
      "id": "ba_176",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Our Testimony")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pAk7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter177#ab_177",
      "id": "ba_177",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("89. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("ISAIAH")]), _vm._v(" 25:4")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "AXA"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter178#ab_178",
      "id": "ba_178",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Strength, Safety, and Shade")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pAgYh"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter179#ab_179",
      "id": "ba_179",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("90. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("REVELATION")]), _vm._v(" 22:20")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "AEWI"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter180#ab_180",
      "id": "ba_180",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Come, Lord Jesus!")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pAdL7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter181#ab_181",
      "id": "ba_181",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("91. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("PSALM")]), _vm._v(" 119:15")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "A0R"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter182#ab_182",
      "id": "ba_182",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Attitude Before Action")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pAy5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter183#ab_183",
      "id": "ba_183",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("92. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("PSALM")]), _vm._v(" 119:38")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "ANsc"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter184#ab_184",
      "id": "ba_184",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wholly Devoted")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pAPi"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter185#ab_185",
      "id": "ba_185",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("93. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("PSALM")]), _vm._v(" 119:33")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "AUH"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter186#ab_186",
      "id": "ba_186",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Obedience")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pAcIe"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter187#ab_187",
      "id": "ba_187",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("94. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("NEHEMIAH")]), _vm._v(" 1:5")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "A_fq"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter188#ab_188",
      "id": "ba_188",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pray with Passion")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pAie"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter189#ab_189",
      "id": "ba_189",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("95. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("PSALM")]), _vm._v(" 35:4")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "AZt0"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter190#ab_190",
      "id": "ba_190",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Confusion for Our Enemies")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pAmrk"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter191#ab_191",
      "id": "ba_191",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("96. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("PSALM")]), _vm._v(" 27:1")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "A_4V"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter192#ab_192",
      "id": "ba_192",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("No Fear")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pAW2-"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter193#ab_193",
      "id": "ba_193",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("97. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("LAMENTATIONS")]), _vm._v(" 3:19")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "AFXi"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter194#ab_194",
      "id": "ba_194",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Remember My Affliction")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pAT0R"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter195#ab_195",
      "id": "ba_195",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("98. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("PSALM")]), _vm._v(" 73:24")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "AiT-"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter196#ab_196",
      "id": "ba_196",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Afterward")])]), _vm._v(" "), _c('p', {
    staticClass: "cct3",
    attrs: {
      "id": "pAxU"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter197#ab_197",
      "id": "ba_197",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("99. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("PSALM")]), _vm._v(" 80:3")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "AVae"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter198#ab_198",
      "id": "ba_198",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Joy Restored")])]), _vm._v(" "), _c('p', {
    staticClass: "cct5",
    attrs: {
      "id": "pAUY"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter199#ab_199",
      "id": "ba_199",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("100. "), _c('span', {
    staticClass: "spell"
  }, [_vm._v("PSALM")]), _vm._v(" 8:3")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct4",
    attrs: {
      "id": "AT6u"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter200#ab_200",
      "id": "ba_200",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Work of His Fingers ")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f6ec521","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contenttoc.vue
// module id = 69
// module chunks = 0